// Copyright © Veeam Software Group GmbH

export enum Routes {
    Index = 'index',
    Explore = 'explore',
    RestoreSessions = 'restore-sessions',
    RecoveryList = 'recovery-list',
}
